import { rebellionHero } from "./rebellion-content"

// Shared with the site graph, which can't prerender this request-time page.
export const rebellionMeta = {
  title: "Join the rebellion",
  description: rebellionHero.intro,
  url: "https://entire.com/rebellion",
}
